namespace Solovis.Reports.Parts.Tables.DataTableHelpers {

  export class ColumnSettingsDialog {

    public _column: Solovis.Reports.Parts.Tables.DataTableHelpers.Column;
    public _dialog: Solovis.UI.Dialog;
    public _formBuilder: Solovis.UI.InputControls.FormBuilder;

    constructor(options) {
      this._column = options.column;
      if (!this._column) {
        throw "options.column not specified";
      }
    }

    public static showDecimalPlacesForDataType(dataType) {
      let showDecimalPlaces = false;
      switch (dataType) {
        case "number":
        case "percentage":
        case "currency":
        case "hybridReturn":
          showDecimalPlaces = true;
      }

      return showDecimalPlaces;
    }

    public show() {
      var self = this;

      if (this._dialog) {
        return;
      }

      let colMods = this._column.mods ? this._column.mods : {};

      let dataType = this._column.dataType;
      let showDecimalPlaces = ColumnSettingsDialog.showDecimalPlacesForDataType(dataType);

      let isNumericDataType = false;
      let isOrderedDataType = false;
      switch (dataType) {
        case "number":
        case "percentage":
        case "currency":
        case "integer":
          isNumericDataType = true;
          isOrderedDataType = true;
          break;

        case "dayId":
        case "utcTimestamp":
        case "valueTypeId":
          isOrderedDataType = true;
          break;
      }

      let isCustomColumn = this._column.id.indexOf("custom_") === 0;

      let tableControl = this._column.columnSet.tableControl;

      // Create data source to pick from any column.
      let allColumnOptionDataSource = [];
      let columnList = tableControl.columnSet.getColumnList();
      for (let otherColumn of columnList) {
        allColumnOptionDataSource.push({
          text: otherColumn.getCompositeLabel(),
          value: otherColumn.id
        });
      }

      let formDiv = $("<div>");

      let formBuilderDiv = $("<div>").appendTo(formDiv);
      let formBuilder = new Solovis.UI.InputControls.FormBuilder({
        container: formBuilderDiv
      });
      this._formBuilder = formBuilder;


      // Decimal Places    
      if (showDecimalPlaces) {
        formBuilder.addEntry({
          name: "decimalPlaces",
          label: "Decimal Places",

          initialValue: colMods.formatHint ? (colMods.formatHint.scale ? colMods.formatHint.scale : null) : null,

          createEditor: function (createEditorOptions) {

            let editorControl = new Solovis.UI.InputControl({
              container: createEditorOptions.container,
              type: "number",
              value: createEditorOptions.initialValue,
              validationModel: createEditorOptions.validationModel,
              min: 0,
              max: 100
            });

            return editorControl;
          }
        });
      }


      // Header Label                
      formBuilder.addEntry({
        name: "headerLabel",
        label: "Header Label",

        initialValue: colMods.label ? colMods.label : null,

        createEditor: function (createEditorOptions) {

          let editorControl = new Solovis.UI.InputControl({
            container: createEditorOptions.container,
            type: "text",
            value: createEditorOptions.initialValue,
            validationModel: createEditorOptions.validationModel
          });

          return editorControl;
        }
      });

      // Super Headers
      formBuilder.addEntry({
        name: "superHeaders",
        label: "Super Headers",

        initialValue: colMods.superHeaders ? colMods.superHeaders : null,

        createEditor: function (createEditorOptions) {
          let mainEditorDiv = createEditorOptions.container;

          let customSuperHeadersToggleDiv = $("<div>").appendTo(mainEditorDiv);
          let toggleCheckbox = $("<input>").attr("type", "checkbox").appendTo(customSuperHeadersToggleDiv);
          toggleCheckbox.prop("checked", Solovis.isNotNull(createEditorOptions.initialValue));

          $("<span>").text("Customize super header labels").css("margin-left", "5px").appendTo(customSuperHeadersToggleDiv);

          let headerListDiv = $("<div>").css("margin-top", "8px").appendTo(mainEditorDiv);

          let headerList = new Solovis.UI.VerticalOrderedListBuilder({
            controlHost: headerListDiv,
            values: createEditorOptions.initialValue,
            editorCreator: function (editorDiv, initialValue) {
              let editorControl = new Solovis.UI.InputControl({
                container: editorDiv,
                type: "text",
                value: initialValue
              });

              let entryEditor = {
                getValue: function () {
                  return editorControl.value();
                }
              };

              return entryEditor;
            }
          });
          headerList.setAsCurrentControl();

          let updateHeaderListVisibility = function () {
            if (toggleCheckbox.is(":checked")) {
              headerListDiv.toggle(true);
            }
            else {
              headerListDiv.toggle(false);
            }
          };

          updateHeaderListVisibility();
          $(toggleCheckbox).bind("change", updateHeaderListVisibility);

          let editor = {
            getValue: function () {
              if (toggleCheckbox.is(":checked")) {
                let headers = headerList.getValues();
                if (!headers) {
                  // We always return at least an empty array to make sure we override defaults.
                  headers = [];
                }

                return headers;
              }
              else {
                return null;
              }
            }
          };

          return editor;
        }
      });

      // Width           
      formBuilder.addEntry({
        name: "width",
        label: "Width",

        initialValue: colMods.width ? colMods.width : null,

        createEditor: function (createEditorOptions) {

          var editorControl = new Solovis.UI.InputControl({
            container: createEditorOptions.container,
            type: "number",
            value: createEditorOptions.initialValue,
            validationModel: createEditorOptions.validationModel
          });

          return editorControl;
        }
      });

      // Text Alignment
      formBuilder.addEntry({
        name: "textAlign",
        label: "Text Alignment",

        initialValue: colMods.textAlign ? colMods.textAlign : null,

        createEditor: function (createEditorOptions) {

          var editorControl = new Solovis.UI.InputControl({
            container: createEditorOptions.container,
            type: "select",
            value: createEditorOptions.initialValue,
            validationModel: createEditorOptions.validationModel,
            data: [
              { text: "Default", value: "" },
              { text: "Left", value: "left" },
              { text: "Center", value: "center" },
              { text: "Right", value: "right" }
            ]
          });

          return editorControl;
        }
      });

      // Header Alignment
      formBuilder.addEntry({
        name: "headerAlign",
        label: "Header Alignment",

        initialValue: colMods.headerAlign ? colMods.headerAlign : null,

        createEditor: function (createEditorOptions) {

          var editorControl = new Solovis.UI.InputControl({
            container: createEditorOptions.container,
            type: "select",
            value: createEditorOptions.initialValue,
            validationModel: createEditorOptions.validationModel,
            data: [
              { text: "Default", value: "" },
              { text: "Left", value: "left" },
              { text: "Center", value: "center" },
              { text: "Right", value: "right" }
            ]
          });

          return editorControl;
        }
      });

      // Line Wrap
      formBuilder.addEntry({
        name: "lineWrap",
        label: "Line Wrap",

        initialValue: Solovis.isNotNull(colMods.noWrap) ? (colMods.noWrap ? "no-wrap" : "wrap") : null,

        createEditor: function (createEditorOptions) {

          var editorControl = new Solovis.UI.InputControl({
            container: createEditorOptions.container,
            type: "select",
            value: createEditorOptions.initialValue,
            validationModel: createEditorOptions.validationModel,
            data: [
              { text: "Default", value: "" },
              { text: "Wrap", value: "wrap" },
              { text: "No Wrap", value: "no-wrap" }
            ]
          });

          return editorControl;
        }
      });


      // Aggregation        
      var aggregatorDataList = [];
      if (isNumericDataType) {
        aggregatorDataList = aggregatorDataList.concat([
          { text: "", value: "" },
          { text: "Sum", value: "sum" },
          { text: "Max", value: "max" },
          { text: "Min", value: "min" },
          { text: "Mean", value: "mean" },
          { text: "Mean (exclude non-values)", value: "meanIfNotNull" },
          { text: "Count", value: "count" },
          { text: "Count (exclude non-values)", value: "countIfNotNull" },
          { text: "Unique Count", value: "uniqueCount" },
          { text: "Unique Count (exclude non-values)", value: "uniqueCountIfNotNull" },
          { text: "Weighted Harmonic Mean", value: "weightedHarmonicMean" },
          { text: "Value If Same", value: "valueIfSame" },
        ]);
      }
      else if (isOrderedDataType) {
        aggregatorDataList = aggregatorDataList.concat([
          { text: "", value: "" },
          { text: "Max", value: "max" },
          { text: "Min", value: "min" },
          { text: "Count", value: "count" },
          { text: "Count (exclude non-values)", value: "countIfNotNull" },
          { text: "Unique Count", value: "uniqueCount" },
          { text: "Unique Count (exclude non-values)", value: "uniqueCountIfNotNull" },
          { text: "Value If Same", value: "valueIfSame" },
          { text: "Pick One", value: "pickOne" },
        ]);
      }
      else {
        aggregatorDataList = aggregatorDataList.concat([
          { text: "", value: "" },
          { text: "Count", value: "count" },
          { text: "Count (exclude non-values)", value: "countIfNotNull" },
          { text: "Unique Count", value: "uniqueCount" },
          { text: "Unique Count (exclude non-values)", value: "uniqueCountIfNotNull" },
          { text: "Value If Same", value: "valueIfSame" },
          { text: "Pick One", value: "pickOne" },
        ]);
      }

      if (isCustomColumn) {
        aggregatorDataList.push({ text: "Formula", value: "formula" });
      }

      formBuilder.addEntry({
        name: "aggregation",
        label: "Aggregation",

        initialValue: (colMods.aggregation && colMods.aggregation.aggregator) ? colMods.aggregation.aggregator : "",

        createEditor: function (createEditorOptions) {

          var editorControl = new Solovis.UI.InputControl({
            container: createEditorOptions.container,
            type: "select",
            value: createEditorOptions.initialValue,
            validationModel: createEditorOptions.validationModel,
            data: aggregatorDataList
          });

          return editorControl;
        }
      });

      formBuilder.addEntry({
        name: "weightColumnId",
        label: "Aggregation Weight Column",

        initialValue: (colMods.aggregation && colMods.aggregation.weightColumnId) ? colMods.aggregation.weightColumnId : "",

        editor: {
          type: "select",
          selectOptions: {
            data: allColumnOptionDataSource,
            searchEnabled: true,
            showClearButton: true
          }
        },

        isVisible: (formEntry) => {
          if (formEntry.formBuilder.getValueByName("aggregation") === "weightedHarmonicMean") {
            return true;
          }
          else {
            return false;
          }
        }
      });


      // Apply Standard Grouping
      formBuilder.addEntry({
        name: "applyStandardGrouping",
        label: "Standard Grouping",

        initialValue: Solovis.isNotNull(colMods.applyStandardGrouping) ? (colMods.applyStandardGrouping ? "yes" : "no") : "",

        createEditor: function (createEditorOptions) {

          var editorControl = new Solovis.UI.InputControl({
            container: createEditorOptions.container,
            type: "select",
            value: createEditorOptions.initialValue,
            validationModel: createEditorOptions.validationModel,
            data: [
              { text: "Default", value: "" },
              { text: "Yes", value: "yes" },
              { text: "No", value: "no" }
            ]
          });

          return editorControl;
        }
      });


      formBuilder.setupDone();

      var desiredWidth = Math.min($(window).width() * .9, 600);
      var desiredHeight = Math.min($(window).height() * .9, 500);


      this._dialog = new Solovis.UI.Dialog({
        container: formDiv,

        title: "Column Settings - " + this._column.definition.label,
        autoOpen: true,
        width: desiredWidth,
        height: desiredHeight,
        center: true,
        modal: true,
        destroyOnClose: true,
        actions: ["Close"],

        buttons: [
          {
            label: "OK",
            click: function () {
              // Check if the form builder has any errors
              if (formBuilder.hasErrors()) {
                // don't apply settings till error is fixed
                return;
              }
              var newColMods = self._column.mods;
              if (!newColMods) {
                newColMods = {};
              }

              var headerLabelValue = self._formBuilder.getValueByName("headerLabel");
              if (headerLabelValue) {
                newColMods.label = headerLabelValue;
              }
              else {
                delete newColMods.label;
              }

              var superHeadersValue = self._formBuilder.getValueByName("superHeaders");
              if (superHeadersValue) {
                newColMods.superHeaders = superHeadersValue;
              }
              else {
                delete newColMods.superHeaders;
              }

              var widthValue = self._formBuilder.getValueByName("width");
              if (widthValue) {
                newColMods.width = parseInt(widthValue);
              }
              else {
                delete newColMods.width;
              }

              var textAlignValue = self._formBuilder.getValueByName("textAlign");
              if (textAlignValue) {
                newColMods.textAlign = textAlignValue;
              }
              else {
                delete newColMods.textAlign;
              }

              var headerAlignValue = self._formBuilder.getValueByName("headerAlign");
              if (headerAlignValue) {
                newColMods.headerAlign = headerAlignValue;
              }
              else {
                delete newColMods.headerAlign;
              }

              var noWrapValue = self._formBuilder.getValueByName("lineWrap");
              if (noWrapValue) {
                newColMods.noWrap = noWrapValue == "no-wrap";
              }
              else {
                delete newColMods.noWrap;
              }

              if (showDecimalPlaces) {
                var decimalPlacesValue = self._formBuilder.getValueByName("decimalPlaces");
                if (Solovis.isNotNull(decimalPlacesValue)) {
                  if (!newColMods.formatHint) {
                    newColMods.formatHint = {};
                  }
                  newColMods.formatHint.scale = decimalPlacesValue;
                }
                else {
                  if (newColMods.formatHint) {
                    delete newColMods.formatHint.scale;
                  }
                }
              }

              let aggregator = self._formBuilder.getValueByName("aggregation");
              if (aggregator) {
                newColMods.aggregation = { aggregator: aggregator };

                if (aggregator === "weightedHarmonicMean") {
                  let weightColumnId = self._formBuilder.getValueByName("weightColumnId");

                  newColMods.aggregation.weightColumnId = weightColumnId;
                }
              }
              else {
                delete newColMods.aggregation;
              }

              let applyStandardGroupingValue = self._formBuilder.getValueByName("applyStandardGrouping");
              if (applyStandardGroupingValue) {
                newColMods.applyStandardGrouping = (applyStandardGroupingValue == "yes") ? true : false;
              }
              else {
                delete newColMods.applyStandardGrouping;
              }

              self._column.updateMods(newColMods);

              self._dialog.close();
            }
          },

          {
            label: "Cancel",
            click: function () {
              self._dialog.close();
            }
          }
        ],
      });

    }
  }

}
